import React, { Component } from 'react';

export default function asyncComponentLoader(importComponent) {
    class AsyncComponentLoader extends Component {
        constructor(props) {
            super(props);
            this.state = {
                component: null
            };
        }

        async componentWillMount() {
            const { default: component } = await importComponent();
            this.setState({ component });
        }

        render() {
            const { component: ChildComponent } = this.state;
            return ChildComponent ? <ChildComponent {...this.props} /> : null;
        }
    }

    return AsyncComponentLoader;
}
